import classNames from 'classnames';

import styles from './styles/amount_badge.module.scss';

export const AmountBadge = ({ type, amount, currency = '', classes }) => {
  const badgeClasses = classNames({
    [styles.amount_badge]: true,
    [styles[`amount_badge--${type}`]]: true,
    [classes]: Boolean(classes),
  });

  return (
    <span className={badgeClasses}>
      {amount} {currency}
    </span>
  );
};
